// extracted by mini-css-extract-plugin
export default {"title":"institut_title__JbFxd","section":"institut_section__NFgWN","missions":"institut_missions__vA-cz","histoire":"institut_histoire__kE1W3","card":"institut_card__QWFh4"};